import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../utils/propUtils';
var VeltInlineCommentsSectionFilterDropdownContentListItemCheckboxWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content-list-item-checkbox-wireframe", __assign({}, transformedProps), children));
};
export default VeltInlineCommentsSectionFilterDropdownContentListItemCheckboxWireframe;
